import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  Toolbar,
  Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import MenuItem from './MenuItem';
import menuItems from './menuItems';
import { MenuItemType } from '../../components/types';

const AppMenu = ({ isUserVerified }: { isUserVerified: boolean }) => {
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  const location = useLocation();

  const getPageTitle = () => {
    if (location.state?.title) {
      return location.state.title;
    }

    // If no location.state.title i.e. entered directly on browser url
    const matchedMenuItem = menuItems.find((menuItem) => {
      return menuItem.path === location.pathname;
    });

    return matchedMenuItem?.title || 'GMD Web App';
  };

  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={() => setOpenMenu(false)}
      onKeyDown={() => setOpenMenu(false)}
    >
      <List>
        {menuItems
          .filter((menuItem: MenuItemType) => {
            if (menuItem.verifiedUsersOnly) {
              return isUserVerified && menuItem.isMenuItem;
            }
            return menuItem.isMenuItem;
          })
          .map((menuItem: MenuItemType, index: number) => {
            const { path, title, icon } = menuItem;
            if (path === 'divider') {
              return <Divider key={index} />;
            }
            return (
              <MenuItem key={path} path={path} title={title} icon={icon} />
            );
          })}
      </List>
    </Box>
  );

  return (
    <AppBar
      sx={{
        display: 'flex',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        margin: 0,
        zIndex: 1,
      }}
      position="static"
    >
      <Toolbar>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={() => setOpenMenu(true)}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {getPageTitle()}
        </Typography>
      </Toolbar>
      <Drawer
        anchor={'left'}
        open={openMenu}
        onClose={() => setOpenMenu(false)}
      >
        {list()}
      </Drawer>
    </AppBar>
  );
};

export default AppMenu;
